import { render, staticRenderFns } from "./TableLicenciaAlcoholesEliminados.vue?vue&type=template&id=630067cb&"
import script from "./TableLicenciaAlcoholesEliminados.vue?vue&type=script&lang=js&"
export * from "./TableLicenciaAlcoholesEliminados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports